<script lang="ts" setup>
import { resolveDisableRules } from "@/utils/disableRules";
import type { Anchor } from "vuetify/framework";
import type { DisableRule } from "@/types/validation";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    rules: DisableRule[];
    location?: Anchor;
  }>(),
  {
    location: "top",
  },
);

const disableState = computed(() => resolveDisableRules(props.rules));
</script>

<template>
  <v-tooltip :disabled="!disableState.disabled" :location="props.location">
    <template #activator="{ props: tooltipProps }">
      <div v-bind="tooltipProps">
        <slot v-bind="{ disabled: disableState.disabled }"></slot>
      </div>
    </template>

    <template v-if="disableState.reasons.length">
      <div>
        <span v-for="(reason, index) in disableState.reasons" :key="index" class="white-space-pre-line">
          {{ reason }}<br v-if="index < disableState.reasons.length - 1" />
        </span>
      </div>
    </template>
  </v-tooltip>
</template>
